import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from '../../../components/modal/Modal';
import { VerifyLawyerModalContent } from '../components/VerifyLawyerModalComponents';
import { BrandButton } from '../../../components/button';
import { RestrictedModalLayout } from '../../../components/modal/components/modal-restricted/RestrictedModalLayout';
import styles from './verify_lawyer_modal_first_step.module.scss';

type Props = {
  lawyerName: string;
  closeModal: () => void;
  isOpen: boolean;
  handleClick: () => void;
};

export const VerifyLawyerModalFirstStep: FC<Props> = ({
  closeModal,
  isOpen,
  lawyerName,
  handleClick,
}) => (
  <Modal isOpen={isOpen} onRequestClose={closeModal}>
    <RestrictedModalLayout closeModal={closeModal} source="verify-lawyer-modal">
      <img src="/img/icons/verify.png" alt="verify-icon" />
      <div className="restricted-modal__title">
        <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/1" />
      </div>
      <VerifyLawyerModalContent>
        <div className={styles.block}>
          <img
            className={styles.icon}
            src="/img/icons/tel.png"
            alt="phone-icon"
          />
          <div className={styles.item}>
            <span className={styles.subtitle}>
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/2" />
            </span>
            <p>
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/3" />
            </p>
          </div>
        </div>
        <div className={styles.block}>
          <img
            className={styles.icon}
            src="/img/icons/email-gray.png"
            alt="email-icon"
          />
          <div className={styles.item}>
            <span className={styles.subtitle}>
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/4" />
            </span>
            <p>
              <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/5" />
            </p>
          </div>
        </div>
      </VerifyLawyerModalContent>
      <div className={styles.button}>
        <BrandButton onClick={handleClick} iconLeft="arrow_forward" large>
          <FormattedMessage id="entity/expertises/VerifyLawyerModalFirstStep.tsx/6" />{' '}
          {lawyerName}
        </BrandButton>
      </div>
    </RestrictedModalLayout>
  </Modal>
);
